import { Input } from "antd";
import { ChevronsDown, ChevronsUp, Send, SendHorizontal } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  addMessageToDemoChat,
  setDemoChatHeight,
  setDemoChatInputValue,
  setIsDemoChatHidden,
} from "../../../store/websites/actions";
import { WebsitesState } from "../../../store/websites/types";
import TypingIndicatorDots from "../../editor/ai2/TypingIndicatorDots";
import "./ChatAgent.scss";
import classNames from "classnames";
import _ from "lodash";

interface Props {
  websites: WebsitesState;
  addMessageToDemoChat: any;
  setIsDemoChatHidden: any;
  setDemoChatInputValue: any;
  setDemoChatHeight: any;
}
const ChatAgent = (props: Props) => {
  const {
    websites,
    addMessageToDemoChat,
    setIsDemoChatHidden,
    setDemoChatInputValue,
    setDemoChatHeight,
  } = props;
  if (!websites.dataFetched) {
    return null;
  }
  const messages = websites.demoChat.messages;

  const timeoutRef = useRef(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const [isTyping, setIsTyping] = useState(false);

  const inputValue = _.get(websites, "demoChat.inputValue", "");
  const setInputValue = (value: string) => {
    setDemoChatInputValue({
      inputValue: value,
    });
  };

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "auto" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (messages.length === 0) {
      addMessageToDemoChat({
        message: {
          type: "agent",
          text: "Hey there!",
        },
      });
      addMessageToDemoChat({
        message: {
          type: "agent",
          text: "I'm a web dev agent, here to help you with your site.",
        },
      });
      addMessageToDemoChat({
        message: {
          type: "agent",
          text: "I'm on vacation right now, but I'll be back on April 25th.",
        },
      });
    }
    // const addFirstMessage = () => {
    //   setIsTyping(false);
    // };
    // if (messages.length === 0) {
    //   timeoutRef.current = setTimeout(addFirstMessage, 2000);
    // }
    // return () => {
    //   clearTimeout(timeoutRef.current);
    // };
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!inputValue) return;
    setIsDemoChatHidden({
      isHidden: false,
    });
    addMessageToDemoChat({
      message: {
        type: "user",
        text: inputValue,
      },
    });
    setInputValue("");
  };

  const isHidden = websites.demoChat.isHidden;
  const onControlsClick = () => {
    setIsDemoChatHidden({
      isHidden: !isHidden,
    });
  };

  const chatAgentRef = useRef<HTMLDivElement>(null);

  const updateChatHeight = () => {
    if (chatAgentRef.current) {
      const height = chatAgentRef.current.offsetHeight;
      if (!height) return; 
      setDemoChatHeight({ height });
    }
  };

  useEffect(() => {
    updateChatHeight();
  }, [isHidden, messages]);

  return (
    <div
      ref={chatAgentRef}
      className={classNames("chat-agent", {
        "is-hidden": isHidden,
      })}
    >
      <div className="chat-agent__wrapper">
        <div className="chat-agent__header">
          <span className="chat-agent__header-text">Talk to agent</span>
          <button className="chat-agent__controls" onClick={onControlsClick}>
            {!isHidden && <ChevronsDown size={16} />}
            {isHidden && <ChevronsUp size={16} />}
          </button>
        </div>
        <div className="chat-agent__messages">
          {messages.map((message, index) => (
            <div key={index} className={`chat-agent__message ${message.type}`}>
              {message.text}
            </div>
          ))}
          {isTyping && (
            <div className="chat-agent__typing">
              <TypingIndicatorDots />
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
        <form className="chat-agent__input" onSubmit={handleSubmit}>
          <Input
            placeholder="Ask anything"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          {!!inputValue && (
            <button className="chat-agent__send">
              <SendHorizontal size={14} />
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    websites: state.websites,
  };
};
export default connect(mapStateToProps, {
  addMessageToDemoChat,
  setIsDemoChatHidden,
  setDemoChatInputValue,
  setDemoChatHeight,
})(ChatAgent);
